<template>
	<div class="timer-container" :class="['el-'+details.id]" :style="style">
		<v-style>
			{{css}}
			{{ numbersStyle }}
			{{labelStyle}}
		</v-style>

		<ul :class="['timer-id-'+details.id, advanced.cssClasses, responsiveClasses, 'timer']"
		    :data-expire="expireAction" :data-expire-url="expireUrl" :data-expire-target="expireTarget"
		    :id="advanced.cssId" v-if="basic.hours && basic.minutes && basic.seconds">
			<li>
				<span class="timer_number" :data-hours="basic.hours.number">
					{{ checkHaveNull((basic.hours ? basic.hours.number : 1), 'hours') }}</span>
				<span class="timer_label">{{ basic.hoursLabel ? basic.hoursLabel : 'Hours' }}</span>
			</li>
			<li>
				<span class="timer_number" :data-minutes="basic.minutes.number">
					{{ checkHaveNull((basic.minutes ? basic.minutes.number : 45), 'minutes') }}</span>
				<span class="timer_label">{{ basic.minutesLabel ? basic.minutesLabel : 'Minutes' }}</span>
			</li>
			<li>
				<span class="timer_number" :data-seconds="basic.seconds.number">
					{{ checkHaveNull((basic.seconds ? basic.seconds.number : 15), 'seconds') }}</span>
				<span class="timer_label">{{ basic.secondsLabel ? basic.secondsLabel : 'Seconds' }}</span>
			</li>
		</ul>
		<ul :class="['timer-id-'+details.id, advanced.cssClasses, responsiveClasses, 'timer']"
		    :id="advanced.cssId" v-else>
			<li>
				<span class="timer_number" data-hours="0">00</span>
				<span class="timer_label">Hours</span>
			</li>
			<li>
				<span class="timer_number" data-minutes="45" >45</span>
				<span class="timer_label">Minutes</span>
			</li>
			<li>
				<span class="timer_number" data-seconds="15">15</span>
				<span class="timer_label">Seconds</span>
			</li>
		</ul>
	</div>
</template>

<script>
import {
	borderProps,
	boxShadow, fontProps,
	getPadding,
	responsiveAlignStyles,
	textDecoration,
	textShadow
} from "@/modules/page-editor/src/utils/props";

export default {
	name: 'EmailTimer',
	props: ['details'],
	computed: {
		basic() {
			return this.details.attributes.basic
		},
		advanced() {
			return this.details.attributes.advanced
		},
		responsive() {
			return this.details.responsive
		},
		responsiveClasses() {
			let c = '';
			if (!this.responsive) return '';
			if (!this.responsive.desktop) c = 'no-desktop';
			if (!this.responsive.mobile) c += ' no-mobile';
			if (!this.responsive.tablets) c += ' no-tablet';
			return c;
		},
		expireAction() {
			let ea = this.basic.expireAction;
			return ea ? ea.mainToggle:'';
		},
		expireUrl() {
			let ea = this.basic.expireAction;
			return ea ? ea.url : '';
		},
		expireTarget() {
			let ea = this.basic.expireAction;
			return ea ? ea.target : '';
		},
		css() {
			return responsiveAlignStyles(this.basic.align, this.details.id);
		},
		numbersStyle() {
			let fontFamily = this.basic.numberFont ? this.basic.numberFont.fontFamily : 'inherit';
			let fontSize = this.basic.numberFont ? this.basic.numberFont.fontSize : '36';
			let textAlign = this.basic.numberFont ? this.basic.numberFont.textAlign : 'center';
			let fontStyling = this.basic.numberFont ? this.basic.numberFont.fontStyling : {};
			let color = this.basic.numberFont ? this.basic.numberFont.color : '#636A7B';
			let backgroundColor = this.basic.numbersBgColor ? this.basic.numbersBgColor : 'none';
			let {borderTop,
				borderLeft,
				borderRight,
				borderBottom,
				borderRadius,
				borderColor} = borderProps(this.basic.numbersBorder);

			return (`.timer-id-${this.details.id} li .timer_number {
				color: ${color};
				border-top: ${borderTop};
				border-left: ${borderLeft};
				border-right: ${borderRight};
				border-bottom: ${borderBottom};
				border-radius: ${borderRadius};
				border-color: ${borderColor};
				background-color: ${backgroundColor};
				font-family: ${fontFamily||'inherit'};
				font-size: ${fontSize}px;
				text-align: ${textAlign||'center'};
				font-weight: ${fontStyling.bold ? 'bold' : 'normal'};
				font-style: ${fontStyling.italic ? 'italic' : 'normal'};
				text-decoration: ${textDecoration(this.basic.numberFont)||'none'};}`);
		},
		labelStyle() {
			let fontFamily = this.basic.labelsFont ? this.basic.labelsFont.fontFamily : null;
			let fontSize = this.basic.labelsFont ? this.basic.labelsFont.fontSize : '16';
			let textAlign = this.basic.labelsFont ? this.basic.labelsFont.textAlign : 'center';
			let fontStyling = this.basic.labelsFont ? this.basic.labelsFont.fontStyling : null;
			let color = this.basic.labelsFont ? this.basic.labelsFont.color : '#b1b2b4';

			return (`.timer-id-${this.details.id} li .timer_label {
				color: ${color};
				font-family: ${fontFamily||'inherit'};
				font-size: ${fontSize}px;
				text-align: ${textAlign||'center'};
				font-weight: ${fontStyling.bold ? 'bold' : 'normal'};
				font-style: ${fontStyling.italic ? 'italic' : 'normal'};
				text-decoration: ${textDecoration(this.basic.labelsFont)||'none'};}`);
		},
		style() {

			return {
				...borderProps(this.advanced.border),
				margin: getPadding(this.basic.margin),
				padding: getPadding(this.advanced.padding),
				backgroundColor: this.advanced.backgroundColor || null,
				textShadow: textShadow(this.advanced.textShadows),
				boxShadow: boxShadow(this.basic.shadows),
			};
		}
	},
	methods: {
		checkHaveNull(val, type) {
			if (val < 10) {
				return ('0' + val)
				// } else if((type == 'hours') && (val > 23)) {
				//     return '00';
				// } else if (((type == 'minutes') || (type == 'seconds')) && (val > 60)) {
				//     return '60';
			} else {
				return val;
			}
		}
	},
}
</script>
